import { render, staticRenderFns } from "./NewAccountButton.vue?vue&type=template&id=6ce646b4&scoped=true&"
import script from "./NewAccountButton.vue?vue&type=script&lang=js&"
export * from "./NewAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce646b4",
  null
  
)

export default component.exports